/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2090
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.OptionTypes = undefined;
(function (e) {
  e[e.TEXT = 0] = "TEXT"
  e[e.VALUE = 1] = "VALUE"
  e[e.ICON = 2] = "ICON"
  e[e.TRIGGER_EVENT = 3] = "TRIGGER_EVENT"
})(exports.OptionTypes || (exports.OptionTypes = {}))
